import React, {Component} from 'react';
import '../pages/pageCss/Home.css';
import projectJson from '../data/projects.json'

class ProCom extends Component {

    constructor() {
        super();
        //Set default message
        this.state = {
        projects: projectJson,
        hovered: false
        }
      }

      onMouseEnter = e => {
        this.setState({ hovered: true });
      };
    
      onMouseLeave = e => {
        this.setState({ hovered: false });
      };

   render(){ 
       const {itemClass, pClass, hClass, imgClass, type, title, img, bgColor, boxShadow} = this.props;
       const { hovered } = this.state;
  return (
    
    <div class={itemClass} style={hovered ? { backgroundColor: bgColor, boxShadow: boxShadow}: {}} onMouseOver={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
        <div>
            <p class={pClass}>{type} </p>
            <h2 class={hClass}>{title}</h2>
        </div>
        <img src={process.env.PUBLIC_URL + "/images/logos/" + img} class={imgClass}/>
    </div>
  );
}
}
export default ProCom;
